import React, { useEffect, useMemo, useState } from "react";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";

const getDefaultOpenState = (storageKey, defaultOpen) => {
  const stored = localStorage.getItem(storageKey);
  if (stored === "true") return true;
  if (stored === "false") return false;

  if (window.matchMedia("(max-width: 1024px)").matches) {
    return false;
  }

  return defaultOpen;
};

const CollapsiblePanel = ({
  id,
  title,
  defaultOpen = true,
  className = "",
  children,
}) => {
  const storageKey = useMemo(() => `sco-collapse-${id}`, [id]);
  const [isOpen, setIsOpen] = useState(() =>
    getDefaultOpenState(storageKey, defaultOpen)
  );

  useEffect(() => {
    localStorage.setItem(storageKey, String(isOpen));
  }, [isOpen, storageKey]);

  return (
    <section
      className={`sco-collapsible-panel ${isOpen ? "is-open" : "is-closed"} ${className}`.trim()}
    >
      <div className="sco-collapsible-header">
        <h2 className="sco-collapsible-title">{title}</h2>
        <button
          type="button"
          className="sco-collapsible-toggle"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-expanded={isOpen}
          aria-controls={`sco-collapse-content-${id}`}
        >
          {isOpen ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
          <span>{isOpen ? "Hide" : "Show"}</span>
        </button>
      </div>
      <div
        id={`sco-collapse-content-${id}`}
        className="sco-collapsible-content"
        hidden={!isOpen}
      >
        {children}
      </div>
    </section>
  );
};

export default CollapsiblePanel;
